import { RackMaterial, Section, ShelfDeck } from '@/shared/types/configurator';

export const INITIAL_SECTIONS: Section[] = [
	{
		height: 2500,
		width: 1720,
		depth: 500,
		selfs: [
			{
				deck: ShelfDeck.SANDED_PARTICLE_BOARD,
			},
			{
				deck: ShelfDeck.SANDED_PARTICLE_BOARD,
			},
			{
				deck: ShelfDeck.SANDED_PARTICLE_BOARD,
			},
			{
				deck: ShelfDeck.SANDED_PARTICLE_BOARD,
			},
		],
	},
];

export const INITIAL_CONFIGURATOR_STATE = {
	sections: INITIAL_SECTIONS,
	doubleSided: false,
	material: RackMaterial.ZN,
	wallMounted: true,
};
